import { pipe } from "fp-ts/lib/function"
import * as O from "fp-ts/Option"

export function isNode(
  eventTarget: EventTarget | null
): asserts eventTarget is Node {
  if (!eventTarget || !("nodeType" in eventTarget)) {
    throw new Error(`Node expected`)
  }
}

export function parseHtml(html: string): O.Option<string> {
  return pipe(
    new DOMParser(),
    domParser =>
      domParser.parseFromString(html, "text/html").documentElement.textContent,
    O.fromNullable
  )
}
